import { render, staticRenderFns } from "./VisitList.vue?vue&type=template&id=680fe94d&scoped=true"
import script from "./VisitList.vue?vue&type=script&lang=js"
export * from "./VisitList.vue?vue&type=script&lang=js"
import style0 from "./VisitList.vue?vue&type=style&index=0&id=680fe94d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680fe94d",
  null
  
)

export default component.exports